import { OptroImportProgressPanel } from "./OptroImportProgressPanel";
import { WorkStepOptroImportProgressPanel } from "./WorkStepOptroImportProgressPanel";
import { useOptroImport } from "../contexts/optroImportContext";
import { useWorkStepOptroImport } from "../contexts/workStepOptroImportContext";

// Owns the corner both Optro import progress panels live in. Concurrent
// controls and work-step imports each render a panel; `flex-col-reverse` keeps
// the controls panel pinned to the bottom (it shipped there first) and stacks
// the work-step panel above it, so neither panel needs to know the other's
// height or position. Each panel renders null when it has no job, so a lone
// panel still sits in the corner. Each panel is keyed by its active import's
// instance key, so its collapsed state and full-view search start fresh for
// every import but survive a pending import getting its server id.
export const OptroImportProgressStack = () => {
  const controlImports = useOptroImport();
  const workStepImports = useWorkStepOptroImport();
  return (
    <div className="fixed bottom-4 right-4 z-50 flex w-96 flex-col-reverse gap-4">
      <OptroImportProgressPanel key={controlImports.activeJob?.instanceKey} />
      <WorkStepOptroImportProgressPanel
        key={workStepImports.activeJob?.instanceKey}
      />
    </div>
  );
};
